import { render, staticRenderFns } from "./ticket-chart-closed.vue?vue&type=template&id=121f2c16"
import script from "./ticket-chart-closed.vue?vue&type=script&lang=js"
export * from "./ticket-chart-closed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports